import React, { useEffect, useCallback } from 'react';

import { paths } from '../paths';
import { useRouter, useSearchParams } from '../hooks';
import { useMonteflor } from "../../hooks/useMonteflor.context";
import { LoadingScreen } from "../../components/loading-screen";

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function GuestGuard({ children }: Props) {
  const { isLoading } = useMonteflor();

  return <>{isLoading ? <LoadingScreen /> : <Container>{children}</Container>}</>;
}

// ----------------------------------------------------------------------

function Container({ children }: Props) {
  const router = useRouter();

  const searchParams = useSearchParams();

  const returnTo = searchParams.get('returnTo') || paths.panel.root;

  const { isAuthenticated } = useMonteflor();

  const check = useCallback(() => {
    if (isAuthenticated) {
      router.replace(returnTo);
    }
  }, [isAuthenticated, returnTo, router]);

  useEffect(() => {
    check();
  }, [check]);

  return <>{children}</>;
}
